module.exports = __webpack_public_path__ + "img/icon-little.51a4aceb.svg";